"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractLibrary = void 0;
const boc_1 = require("../boc");
const [EMPTY_CODE_CELL] = boc_1.BOC.from('B5EE9C7241010101000A000010FF00F800C8C9FB041D179D63');
class ContractLibrary {
    constructor(code, isPublic) {
        this.code = code;
        this.isPublic = isPublic;
    }
    static get EmptyCode() {
        return EMPTY_CODE_CELL;
    }
}
exports.ContractLibrary = ContractLibrary;
//# sourceMappingURL=libraries.js.map